import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobile } from '@fortawesome/pro-solid-svg-icons';
import { useTranslation } from '../../../i18n/i18n';
import HostedStatusBlock from '../../../components/hosted/StatusBlock';

/** Continue in the app: the rising phone on its own, at the size of the Done check. */
export default function HostedWaitingScreen() {
  const { t } = useTranslation();
  return (
    <HostedStatusBlock
      visual={
        <div
          aria-hidden="true"
          className="flex items-center justify-center size-10 overflow-hidden rounded-full bg-muted-foreground text-card [&>svg]:animate-embedded-rise"
        >
          <FontAwesomeIcon icon={faMobile} className="size-5" />
        </div>
      }
      title={t('waitingForPresentation.title')}
      subtitle={t('waitingForPresentation.hint')}
    />
  );
}
